import { Container } from './questionnaire.styles';
import Progress from '../Progress';
import Questions from '../Questions';
import { FC } from 'react';

enum QuestionCategory {
  strategy = 'strategy',
  transparency = 'transparency',
  burnLess = 'burnLess',
  burnClean = 'burnClean',
}

export interface QuestionOption {
  id: string;
  value: string;
}

export interface Question {
  category: QuestionCategory;
  question: string;
  questionId: string;
  questionOptions?: QuestionOption[];
  isMultiChoice?: boolean;
}

interface Props {
  questions: Question[];
}

const Questionnaire: FC<Props> = ({ questions }) => (
  <Container>
    <Progress />
    <Questions questions={questions} />
  </Container>
);

export default Questionnaire;
